<template>
  <div>
    <el-row v-if="editAble">
      <el-upload
        :limit="limit"
        :accept="accept"
        :action="upload.url"
        :headers="upload.headers"
        :show-file-list="false"
        name="file"
        :multiple="true"
        :data="initParam"
        :file-list="upload.fileList"
        :on-progress="handleFileUploadProgress"
        :before-upload="handleBeforeUpload"
        :on-success="handleFileSuccess"
        :on-exceed="handleExceed"
        :auto-upload="true"
        :disabled="!editAble">
        <template >
          <el-button icon="el-icon-upload" slot="trigger" size="mini" type="primary" :loading="upload.isUploading">上传{{typeName==''?'文件':typeName}}</el-button>
          <span slot="tip" class="el-upload__tip" style="color:#F56C6C;margin-left:5px;">
            <div style="line-height: 25px;" v-if="acceptShow">格式为{{accept}}</div>
          </span>
        </template>
      </el-upload>
    </el-row>
    <el-row>
      <div v-for="file in upload.fileList" :key="file.fileId">
        <div style="display: flex;justify-content: space-between;margin-bottom: 10px;" >
          <div class="file-left" >
              <span class="file-item" @click="handleDownload(file)" :title="'点击下载”'+file.fileName+'“'">{{ file.fileName }}</span>
          </div>
          <div>
            <el-button size="mini" type="danger" v-if="editAble" @click="handleDelete(file,upload.fileList)">删除</el-button>
          </div>
        </div>
      </div>
    </el-row>
  </div>
</template>
<script>
  import {getToken} from "@/utils/auth";
  import { delAttachment, listNoPageAttachment, getFileSize } from "@/api/system/attachment";
  import SsoConfig from "@/SsoConfig";

  export default {
    name: 'AttachmentSingleModule',
    props: {
      //模块名
      module: {
        type: String,
        required: true
      },
      //文件id标识
      businessid: {
        type: String,
        required: true
      },
      //上传类型名称
      typeName:{
        type: String,
        required: true
      },
      //是否显示允许上传的文件类型
      acceptShow: {
        type: Boolean,
        default: true
      },
      //是否启用上传
      editAble: {
        type: Boolean,
        default: true
      },
      //允许上传的文件类型
      accept: {
        type: String,
        default: ".bmp, .gif, .jpg, .jpeg, .png, .doc, .docx, .xls, .xlsx, .ppt, .pptx, .txt, .rar, .zip, .gz, .bz2, .pdf"
      },
      //最大上传数量
      limit: {
        type:Number,
        default:1
      },
      //是否返回数量
      isReturn: {
        type: Boolean,
        default: false
      },
      //是否显示预览按钮
      previewShow: {
        type: Boolean,
        default: true
      }
    },
    data() {
      return {
        loading: false,
        // 上传参数
        upload: {
          // 是否禁用上传
          isUploading: false,
          // 设置上传的请求头部
          headers: {Authorization: "Bearer " + getToken()},
          // 上传的地址
          url: process.env.VUE_APP_BASE_API + "/web/attachment/upload",
          // 上传的文件列表
          fileList: [],
        },
        maxFileSize: 10
      }
    },
    computed: {//将参数转化成计算属性
      initParam() {
        return {
          module: this.module,
          businessid: this.businessid
        }
      }
    },
    watch: {//监听计算属性变化
      initParam: {
        handler(val) {
          //值变化是初始化
          if(val.businessid!=null&&val.businessid!=undefined){
            this.initAttachment();
          }
        },
        deep: true,
        immediate: true
      },
    },
    methods: {
      //初始化附件列表
      initAttachment() {
        this.getAttSize();
        this.getAttList();
      },
      //单个附件允许上传大小
      getAttSize(){
        getFileSize().then(response => {
          if(response.data!=null && response.data.maxFileSize!=null){
            this.maxFileSize = response.data.maxFileSize;
          }
        })
      },
      //查询附件列表
      getAttList() {
        this.upload.isUploading = true;
        this.upload.fileList = [];
        listNoPageAttachment(this.initParam).then(response => {
          this.upload.isUploading = false;
          for (let temp of response.rows) {
            if(temp.module == this.initParam.module){
              this.upload.fileList.push({
                ...temp,
                name: temp.fileName
              });
            }
          }
          if(this.isReturn){
            this.$emit('getFileCount', { module:this.module, count: this.upload.fileList.length });
          }
        });
      },
      // 上传前校检格式和大小
      handleBeforeUpload(file) {
        // 校检文件大小
        const isLt = file.size / 1024 / 1024 < parseInt(this.maxFileSize);
        if (!isLt) {
          this.upload.isUploading = false;
          this.msgError(`上传文件大小不能超过 ${this.maxFileSize}MB!`);
          return false;
        }
        return true;
      },
      // 文件上传中处理
      handleFileUploadProgress(event, file, fileList) {
        this.upload.isUploading = true;
      },
      // 文件上传成功处理
      handleFileSuccess(response, file, fileList) {
        this.upload.isUploading = false;
        if (response.code == 200) {
          this.msgSuccess(response.msg);
          for (let temp of fileList) {
            if (temp.uid == file.uid) {
              Object.assign(temp, response.data);
            }
          }
          this.getAttList();
          // if(this.isReturn){
          //   this.$emit('getFileCount', { module:this.module, count: fileList.length });
          // }
        } else {
          this.msgError(response.msg);
        }
      },
      //文件超出个数限制
      handleExceed(files, fileList) {
        this.msgError("最多只能上传"+ this.limit +"个文件！");
      },
      // 删除按钮操作
      handleDelete(file, fileList) {
        let fileIds = file.fileId;
        if(fileIds) {
          return this.$confirm('是否确认删除' + file.fileName + '附件?', "警告", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }).then(function () {
            return delAttachment(fileIds);
          }).then(() => {
            /*if(this.isReturn){
              this.$emit('getFileCount', {module: this.module, count: (fileList.length - 1)});
            }*/
            this.getAttList();
            this.msgSuccess("删除成功");
          }).catch(function () {
            reject(false);
          });
        }
      },
      //文件下载
      handleDownload(file) {
        var name = file.fileName;
        var url = file.path;
        const a = document.createElement('a');
          a.setAttribute('download', name);
          a.setAttribute('target', '_blank');
          a.setAttribute('href', process.env.VUE_APP_BASE_API + url);
          a.click();
      },
      handlePreview(file){
        let suffix = file.suffix.toLowerCase();
        if(!SsoConfig.previewFileTypes.includes(suffix)){
          this.msgWarning("文件无法预览，请下载查看");
          return;
        }
        let viewPath = process.env.VUE_APP_BASE_API + file.path;
        //跳转新窗口打开
        let queryParam = { title:file.fileName, suffix:suffix, previewUrl: viewPath };
        let queryStr = this.Base64.encode(JSON.stringify(queryParam));
        const routeData = this.$router.resolve({
          path: '/file/preview', // 路由
          query:{ queryParam: queryStr }
        });
        window.open(routeData.href, '_blank');
      }
    }
  }
</script>
<style scoped>
  .attachment-title {
    line-height: 30px;
    font-size: 14px;
  }
  .file-left{
    flex: 1; /* 使元素扩展以填满可用空间 */
    //line-height: 16px;
    overflow: hidden; /* 隐藏溢出的内容 */
    /*white-space: nowrap; *//* 防止文本换行 */
    text-overflow: ellipsis; /* 显示省略号 */
    //white-space: normal;
    //word-break: break-word;
  }
  .file-item:hover{
    cursor: pointer;
    color: #BE0001;
  }
</style>
